import { Component, OnInit } 									    from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } 	    from '@angular/forms';
import { ErrorStateMatcher } 										from '@angular/material/core';

import { Router, ActivatedRoute } 								    from '@angular/router';
import { first } 												    from 'rxjs/operators';

import { AlertService, StudentService } 					    	from '../_services';
import { Globals}                                                   from '../_helpers';

import { Subject } 													from 'rxjs';
import { Observable,throwError } 									from 'rxjs';


@Component({
  selector: 'app-home',
  templateUrl: './students.component.html'
})


export class StudentsComponent implements OnInit {

  	loading = false;
    submitted = false;    
    returnUrl: string;
    imagePath : string;
    students = [];
    localData = {};
    activeExam = {};
    theorystatus: number = 0;
    vivastatus: number = 0;
    bothstatus: number = 0;
    notattempt: number = 0;
    viva_assessor: number
    viva_pc: number = 0;
    practical_viva: number = 0;
    examid:number = 0;
    
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private studentService: StudentService,
        private alertService: AlertService,
        private globals: Globals
    ) {}

    ngOnInit() {
    	this.localData = JSON.parse(localStorage.getItem('currentUser'));
      this.activeExam = JSON.parse(localStorage.getItem('activeExam_PS'));
    	this.imagePath = '/assets/images/pic-upload.png';

        // get return url from route parameters or default to '/'
        this.returnUrl = '/';

        /* Call on load function */
        this.viva_assessor = this.activeExam['viva_assessor'];
        this.viva_pc = this.activeExam['vivapc'];
        this.practical_viva = this.activeExam['viva_practical'];
        this.examid = this.activeExam['exam_id'];        

		this.getStudentsData();
    }
    
    theory4status = 0
    theory2status = 0
    pracstatus = 0
    descstatus = 0
    matrixstatus = 0
    virtustatus = 0
    adaptivestatus = 0
    psycostatus = 0
    private getStudentsData(){
    	this.submitted = true;
    	this.studentService.getStudentsForBatch(this.globals.root_url, this.localData['usercode'],this.localData['id'], this.localData['exam_id'])
            .pipe(first())
            .subscribe(
    	        data => {
                    //console.log(data);
                    if(data.code == 1000){
                        this.students = data.students;
                        var theory = 0, viva = 0, both = 0, notattempt = 0, theory4 = 0, theory2 = 0, viva2 = 0, descriptive = 0,matrix=0,adaptive=0,psyc=0,vc=0,exam_screen=0;
                          this.students.forEach(function (value) {
                                if(value.vivadone == 1) theory = theory + 1;
                                if(value.vivadone == 2) viva = viva + 1;                            
                                if(value.vivadone == 3) both = both + 1;
                                if(value.vivadone == 0) notattempt = notattempt + 1;                           
                                if(value.theory4_done == 1) theory4 = theory4 + 1;
                                if(value.theory2_done == 1) theory2 = theory2 + 1; 
                                if(value.descriptive_done == 1) descriptive = descriptive + 1;   
                                if(value.matrix_done == 1) matrix = matrix + 1;
                                if(value.practical_done == 1) viva2 = viva2 + 1;
                                if(value.vc_done == 1) vc = vc + 1;
                                if(value.adaptive_done == 1) adaptive = adaptive + 1;
                                if(value.psyc_done == 1) psyc = psyc + 1;
                                if(value.exam_screen == 1) exam_screen = exam_screen + 1;
                          }); 
                        this.theorystatus = theory;
                        this.theory4status = theory4;
                        this.theory2status = theory2;
                        this.vivastatus = viva;
                        this.pracstatus = viva2;
                        this.descstatus = descriptive;
                        this.matrixstatus = matrix;
                        this.virtustatus = vc;
                        this.adaptivestatus = adaptive;
                        this.psycostatus = psyc;
                        this.bothstatus = both;
                        this.notattempt = notattempt;
                    }
                    else if(data.status == 'COM_TOKEN_ERROR'){
                        this.loading = false;
                        this.router.navigateByUrl('/login');
                    }
                    else{
                        
                    }
    	        },
    	        error => {
    	            this.alertService.error(error);
    	            this.loading = false;
    	        }
    	    );
    }

    public printStudents(){
        document.getElementById("dashbutton").style.display = "none";
        window.print();
        document.getElementById("dashbutton").style.display = "block";
    }
    public gotoDashboard(){
        this.router.navigateByUrl('/home/' + this.examid+'/'+this.viva_assessor+'/'+this.viva_pc+'/'+this.practical_viva);
    }  
    public gotoDExamList(){
        this.router.navigateByUrl('/exam-list'); 
    }       
}
